module.exports = __webpack_public_path__ + "static/img/gaojian.47b0954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/gaojian.png
// module id = Uoib
// module chunks = 0